import { Button, IconButton, Theme, styled } from '@material-ui/core';

export const ButtonWrapper = styled(IconButton)<Theme>(({ theme }) => ({
  width: '4rem',
  height: '4rem',
  background: theme.palette.common.white,
  border: theme.config.defaultBorder(theme.palette.grey['200']),
  borderRight: 'none',
  borderRadius: 0,

  '&:last-child': {
    borderRight: theme.config.defaultBorder(theme.palette.grey['200']),
  },
}));

export const StyledLargeButton = styled(Button)<Theme>(({ theme }) => ({
  textTransform: 'none',
  width: '100%',
  height: '100%',
  display: 'block',
  textAlign: 'left',
  margin: theme.spacing(1, 0),
  padding: theme.spacing(3),
  backgroundColor: theme.palette.common.white,
  borderRadius: theme.config.borderRadiusCluster,
  flexDirection: 'column',
  border: `1px solid ${theme.config.appbarColors.borderColor}`,

  '&:hover': {
    backgroundColor: theme.config.appbarColors.background,
  },
}));

export const Title = styled('h3')<Theme>(({ theme }) => ({
  fontSize: theme.typography.h3.fontSize,
  margin: theme.spacing(1, 0),
}));

export const Description = styled('p')<Theme>(({ theme }) => ({
  fontStyle: 'italic',
  color: theme.palette.grey['600'],
  margin: 0,
}));

export const GroupWrapper = styled('div')<Theme>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  marginBottom: '2rem',
  gap: theme.spacing(1),
  '&.show-on-hover': {
    width: '100%',
    minHeight: 50,
    '&.show-on-hover > *': {
      transition: 'visibility 300ms, opacity 300ms',
      visibility: 'hidden',
      opacity: 0,
    },
    '&.show-on-hover:hover > *': {
      visibility: 'visible',
      opacity: 1,
    },
  },
}));

export const GroupTitle = styled('h4')<Theme>(({ theme }) => ({
  marginRight: theme.spacing(2),
  fontSize: theme.typography.h4.fontSize,
}));

export const StyledGroup = styled('div')({
  overflow: 'hidden',
});
